<template>
  <div>
    <!-- <side-bar>
      <mobile-menu slot="content"></mobile-menu>
    </side-bar> -->

    <div class="">
      <TopNavbar />

      <div class="contact-us">
        <b-img :src="require('@/assets/img/landing_page/Banner_CD_Avance_06.webp')" alt="Banner Correduria Digital" fluid></b-img>
      </div>

      <ComoFunciona />

      <a id="servicios"></a>
      <Servicios2025 />

      <a id="registro"></a>
      <SignIn id="registrar" class="registro" />

      <a id="testimonios"></a>
      <TestimoniosComponent id="testimonios" />

      <a id="contacto"></a>
      <Contacto id="contacto" />

      <Footer />
    </div>
  </div>
</template>

<script>
  import TopNavbar from "src/layout/TopNavbar.vue";
  import ComoFunciona from "src/pages/landingPage/ComoFunciona.vue";
  // import Servicios from "src/pages/landingPage/Servicios.vue";  
  // import Typography from "./Typography.vue";
  import Contacto from "src/pages/landingPage/Contacto.vue";
  // import QuienesSomos from "src/pages/landingPage/QuienesSomos.vue";

  import SignIn from "src/pages/SignIn.vue";

  import Footer from "src/layout/ContentFooter.vue";
  import MobileMenu from "src/layout/MobileMenu.vue";

  import config from "@/config";
  import TestimoniosComponent from "./landingPage/TestimoniosComponent.vue";
  import Servicios2025 from "src/pages/landingPage/Servicios2025.vue";

  export default {
    name: "Home",

    data: () => ({
      show_side: false,
      publicPath: config.BASE_URL
      // disabled: false,
      // user: null,
      // password: null,
      // invalid: false,
      //  msg: "",
      // role: "",
    }),

    components: {
      TopNavbar,
      ComoFunciona,
      // Servicios,
      // Typography,
      Contacto,
      // QuienesSomos,
      MobileMenu,
      SignIn,
      Footer,
      TestimoniosComponent,
      Servicios2025
    },

    methods: {
      toggleSidebar() {
        // console.log(this.$sidebar.displaySidebar);
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false);
        }
      }
    }
  };
</script>

<style scoped>
  .contact-us {
    display: flex;
    justify-content: center;
    background-color: #f7f7f8;
    padding: 0px;
    margin: 0px;
  }

  .landing {
    background-color: #f7f7f8;
  }

  #wrapper {
    width: auto;
    margin: 0 auto;
  }

  #titulo {
    font-family: "Gill Sans MT", "Gill Sans", "Trebuchet MS", sans-serif !important;
  }

  #index {
    background-image: url("../assets/img/landing_page/Banner_CD_Avance_06.webp");
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    object-fit: contain;
  }

  /* #cardText {
    position: absolute;
    top: 55%;
    left: 50%;
    transform: translate(-50%, -50%);
  } */

  .registro {
    background-color: #f7f7f8;
  }
</style>